import { useState } from 'react';
import { Message, Icon } from 'semantic-ui-react';
import ErrorDisplay from '../ErrorDisplay/ErrorDisplay';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
const MurphyStatusDisplay = ({ videoStatus, error, loadNewAssessment }) => {
    const [newAssessmentLoaded, setNewAssessmentLoaded] = useState(false);

    useEffect(() => {
        if (videoStatus === 'graded') {
            loadNewAssessment().then(() => {
                setNewAssessmentLoaded(true);
            });
        } else {
            setNewAssessmentLoaded(false);
        }
    }, [videoStatus, loadNewAssessment]);

    if (error === 'permanently_failed') {
        return <ErrorDisplay message="Murphy was unable to grade this practice session. Please try recording again. If the issue persists, contact support." />;
    }

    if (error === 'upload_failed') {
        return <ErrorDisplay message="Your recording didn't upload, so it hasn't been saved. This is usually a camera/microphone permission or network issue. Please make sure your camera and mic are allowed, then record again. If the issue persists, contact support." />;
    }

    // NOTE: these device/permission variants MUST stay above the generic `if (error)` below.
    // They are keyed to specific getUserMedia failure causes (see classifyMediaError in
    // NewRecordPresentation). Do not merge their copy into the generic grading-delay branch —
    // that branch is for genuine grade timeouts and has overwritten device guidance before.
    if (error === 'device_not_found') {
        return <ErrorDisplay message="We couldn't detect a working microphone or camera. Please check that they're connected and that microphone/camera access is enabled in your browser and your operating system settings, then click Start to try again." />;
    }

    if (error === 'permission_denied') {
        return <ErrorDisplay message="Microphone and camera access is blocked. Please allow access for this site in your browser's permission settings (and check your operating system's privacy settings), then try again." />;
    }

    if (error) {
        return <ErrorDisplay message="Murphy is taking longer than usual to grade your practice. Your video has been saved and Murphy will continue working on it. Please check back shortly for your feedback." />;
    }

    if (!videoStatus) {
        return null;
    }

    let message = '';

    if (videoStatus === 'loading') {
        message = 'Murphy is preparing new questions from your document...';
    } else if (videoStatus === 'uploading') {
        message = 'Uploading Video...';
    } else if (videoStatus === 'transcribing') {
        message = 'Your video is currently being transcribed.  This can take several minutes.';
    } else if (videoStatus === 'grading' || (videoStatus === 'graded' && !newAssessmentLoaded)) {
        message = 'Murphy is now grading your video.';
    } else if (videoStatus === 'graded' && newAssessmentLoaded) {
        message = <>
            Murphy is all finished.  You can view your report{' '}
            <Link to="/my-assessments-report" style={{ textDecoration: 'underline', fontWeight: 'bold', color: '#06718f' }}>here</Link>.
        </>;
    }

    return (
        <div className="murphy-status">
            {videoStatus !== 'graded' && videoStatus !== '' && (
                <div className="loading-icon">
                    <Icon name='circle notched' loading />
                </div>
            )}
            <div className="status-content">
                <div className="status-message">{message}</div>
            </div>
        </div>
    );
};

export default MurphyStatusDisplay;